import { AccountType } from './account-type';

export interface LiveCallsRow {
    id: number;
    sid: string;
    createdAt: Date;
    from: string;
    fromName: string;
    direction: TwilioDirection;
    domainId: string;
    to: string;
    toName: string;
    status: TwilioQueueStatus;
    state: TwilioQueueState;
    duration: number;
    data: any;
    callOutSid: string;
    confId: string;
    log: string[];

    userIdFrom: string;
    contactIdFrom: string;
    companyIdFrom: string;
    companyIdTo: string;
    contactIdTo: string;
    userIdTo: string;
}

export enum TwilioDirection // it's more about what state is queue databse record, more technical state
{
    Internal = 'Internal',
    Outbound = 'Outbound',
    Inbound = 'Inbound'
}

export interface TwilioAgentModel {
    id: string;
    firstname: string;
    surname: string;
    accountType: AccountType;
    avatarColour: string;
    callTimeOut: number;
    callPrior: number;
    mobile: string;
    landline: string;
    altPhone: string;
    phone: string;
    domainId: string;
    numberId: string;
    inbound: string;
    availableForInbound: boolean;
    isDeviceBusy: boolean;
}

export enum TwilioQueueStatus
{
    default = 0,
    Initiated = 1,
    Waiting = 2, // when caller waits for an answer or in private calls agent waits in the conference
    Talking = 3, // when parties talk on the phone
    Redirect = 4, // When customer is redirected to another agent
    OnHold = 5, // When callee are on hold
    NoAgents = 6, // When there are no agents
    AskCallback = 7, // when asked for if want's to be calledback
    Callback = 8, // when caller wants to be called back
    Closed = 9, // when office is closed
    Calling = 10, // when calling mainly in private calls
    NoAnswer = 11, // When no answer message
    Busy = 12, // When no answer message
    Error = 13, // When no answer message
    LeftAMessage = 14, // When no answer message
}

export enum TwilioQueueState // it's more about what state is queue databse record, more technical state
{
    default = 0,
    Active = 1, // when call haven't died yet and we can do something with it
    Busy = 2, // processing conversation should not be touched by other scripts
    Done = 3,  // When conversation ended properly - nothing to do with it further
}

export interface TwilioCallStats {
    onlineAgents: number;
    availableAgents: number;
    activeCalls: number;

    inboundCalls: number;
    outboundCalls: number;

    callbacks: number;
    voiceMessages: number;

    waitTime: number;
    averageWaitTime: number;

    liveCalls: number;
}
